import {getData, postData, deleteDataMethod} from 'helpers/Helper'
import { APP_PATH, GET_FAQ, ADD_FAQ, UPDATE_FAQ, VIEW_FAQ, DELETE_FAQ, UPDATE_STATUS_FAQ } from './apiPath'
import { getFAQ, addFAQ, updateFAQ, viewFAQ, deleteFAQ, updateStatusFAQ} from 'store/actions/faq';
export function getFAQ_(value, callback) {
  const { page, limit, url, common } = value || {};
  let urlPath = `${APP_PATH}${GET_FAQ}`;
  if (page !== undefined && limit !== undefined) {
      urlPath += `?page=${page}&limit=${limit}`;
  } 
  return (dispatch) => getData(urlPath, value)
    .then((data) => {
      dispatch(getFAQ(data, callback));
      return data;
 });
}
//add 
export function addFAQ_(value, callback) {
  return (dispatch) => postData(`${APP_PATH}${ADD_FAQ}`, value)
    .then((data) => {
      dispatch(addFAQ(data, callback));
      return data;
    });
}


//view
export function viewFAQ_(value, callback) {
  let url = `${APP_PATH}${VIEW_FAQ}${value}`;
  return (dispatch) => getData(url, value)
    .then((data) => {
      dispatch(viewFAQ(data, callback));
      return data;
 });
}

export function updateFAQ_(value, callback) {
  return (dispatch) => postData(`${APP_PATH}${UPDATE_FAQ}`, value)
    .then((data) => {
      dispatch(updateFAQ(data, callback));
      return data;
    });
}

export function deleteFAQ_(value, callback) {
  let url = `${APP_PATH}${DELETE_FAQ}${value?.id}`;
  return (dispatch) => deleteDataMethod(url)
    .then((data) => {
      dispatch(deleteFAQ(data, callback));
      return data;
    });
}

export function updateStatusFAQ_(value, callback) {
  return (dispatch) => postData(`${APP_PATH}${UPDATE_STATUS_FAQ}${value?.id}`, value)
    .then((data) => {
      dispatch(updateStatusFAQ(data, callback));
      return data;
    });
}